import { ArticleProductWrapperProps } from '../components/ArticleProductWrapper/ArticleProductWrapper';
import { contentfulProductSummaryToArticleProductProps } from './contentfulProductSummaryToArticleProductProps';
import { ContentfulContentWrapper } from '@jbhi-fi/apis/src/contentful/types';
import { AssetTransformer } from '@jbhi-fi/components/src/Contentful/transformers/AssetTransformer';

export const contentfulContentWrapperToArticleProductWrapper = ({
  fields,
}: ContentfulContentWrapper): ArticleProductWrapperProps => {
  const heroImage = AssetTransformer.toImageProps(fields?.heroImage);

  return {
    productVariantIds: (fields?.featuredProducts.map(product => product.fields?.product).filter(Boolean) ??
      []) as Array<string>,
    imgSrc: heroImage?.src ?? '',
    imgAlt: heroImage?.alt ?? '',
    articleProducts:
      fields?.featuredProducts.map(product => contentfulProductSummaryToArticleProductProps(product)) ?? [],
  };
};
